// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout */

/* ======================================= */
/* 🌟 MINIMALIST SCROLLBAR STYLING (WEBKIT) 🌟 */
/* ======================================= */

/* 1. Target the main scrollbar track (the background area) */
::-webkit-scrollbar {
    width: 8px; /* Width of the entire scrollbar */
}

/* 2. Target the thumb (the moving bar) */
::-webkit-scrollbar-thumb {
    /* Base style for the thumb */
    background-color: #555; /* Dark gray color (visible against #303030) */
    border-radius: 4px; /* Slightly rounded corners */
}

/* 3. Hover effect for the thumb (optional, but nice touch) */
::-webkit-scrollbar-thumb:hover {
    background-color: #777; /* Lighter color on hover */
}

/* 4. Target the track (the area behind the thumb) */
::-webkit-scrollbar-track {
    /* Make the track transparent or match the background */
    background: transparent; 
}

/* Optional: To customize scrollbars in specific elements like the sidebar */
.sidebar::-webkit-scrollbar {
    width: 6px; /* A little thinner for the sidebar */
}

.sidebar::-webkit-scrollbar-thumb {
    background-color: #6a6a6a;
}

.dashboard {
    display: grid;
    grid-template-columns: 0px 1fr;
    grid-template-rows: 60px 1fr;
    min-height: 100vh;
    background: #303030;
    color: white;
    transition: grid-template-columns 0.3s ease;
    padding-top: 84px;
}

.dashboard.sidebar-open {
    grid-template-columns: 250px 1fr;
}

/* Header */
.dashboard-header {
    grid-column: 1 / -1;
    grid-row: 1;
    display: flex;
    align-items: center;
    background: #424242;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 80px;
    padding: 0px 30px;
    height: 60px;
    width: 100%;
    border-top: 4px solid #303030;
    z-index: 100;
}

.dashboard-header h1 {
    font-family: 'GlitchGoblin', sans-serif;
    letter-spacing: 3px;
    font-size: 25px;
}

/* Hamburger button - desktop only */
.hamburger_dashboard {
    cursor: pointer;
    font-size: 30px;
    margin-right: 20px;
    color: white;
    display: block;
}

.dashboard-welcome {
    grid-row: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 144px;

    /* Size based on text content */
    width: fit-content;
    padding: 10px 10px;
    height: 20px;

    /* Rounded bottom corners */
    border-radius: 0px 0px 20px 20px;

    /* 👇 Center horizontally */
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
}


.dashboard-welcome h1 {
    font-size: 15px;
    margin: 0px 5px;
    font-weight: 300;
}

/* Sidebar */
.sidebar {
    background: #424242;
    height: calc(100vh - 0%);
    position: fixed;
    border-right: 1px solid #555;
    overflow: auto;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    margin: 60px 0%;
    z-index: 100;
    /* Adjusted width to 250px to provide better padding space */
    width: 250px; 
}

.sidebar.open {
    transform: translateX(0);
}

.sidebar.open h2 {
    font-size: 20px;
}

.sidebar h2 {
    color: white;
    margin-bottom: 5px;
}

/* UPDATED: Container for list items */
.sidebar ul {
    list-style: none;
    padding: 10px 10px; /* Added horizontal padding to create "floating" space */
    margin-top: 0px;
}

/* 🌟 UPDATED: RECTANGULAR MENU ITEM WITH CURVED CORNERS 🌟 */
.sidebar li {
    /* Style for the rectangular shape */
    display: block; 
    color: white;
    font-size: 15px;
    list-style: none; /* removes the bullet */
    cursor: pointer;
    font-weight: 500;
    
    /* 1. Rectangular Shape & Curve */
    padding: 12px 15px; /* Vertical and horizontal padding inside the box */
    margin: 8px 0; /* Vertical spacing between menu items */
    border-radius: 8px; /* ⬅️ CURVED CORNERS */
    
    /* Base background color and transitions */
    background-color: #5a5a5a;
    border-bottom: none; /* Remove old list item divider */
    transition: background-color 0.3s ease, color 0.3s ease;
}

.sidebar li:hover {
    color: #424242; /* Darker text on hover */
    background-color: #f8f8f8; /* Highlight the rectangular item */
}

/* Style for the actively selected menu item */
.sidebar li.active {
    background-color: #007bff; /* Primary color for the active item */
    color: white; 
    font-weight: 700;
    box-shadow: 0 1px 3px rgba(0, 123, 255, 0.4);
}

.menu-section {
    padding: 5px 15px;
}

/* Main Content */
.main-content {
    grid-column: 2;
    grid-row: 2;
    padding: 30px 10px;
    background: #303030;
    overflow-y: auto;
}

.main-content h1 {
    color: white;
    font-size: 25px;
    font-weight: 400;
    text-align: center;
}

.username {
    font-size: 15px;
    font-weight: 600;
    list-style: none;
    color: #007bff;
    padding-right: 2px;
}

/* FAB button for mobile */
.fab {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    font-size: 30px;
    cursor: pointer;
    display: none;
    z-index: 100;
}

/* Show FAB only on mobile */
@media (max-width: 770px) {
    .fab {
        display: block;
        
    }
    
    .hamburger_dashboard {
        display: none;
    }
    
    .dashboard {
        padding-top: 70px;
    }
    
    .dashboard-header {
        justify-content: center;
        padding: 0%;
        top: 82px;
        border-top: 4px solid #303030;
    }
    
    .dashboard-header h1 {
        font-size: 18px;
    }
    
    .main-content h1 {
        font-size: 18px;
        margin: 1% 0%;
    }
    
    .main-content {
        padding: 70px 15px;
    }
    
    .username {
        font-size: 110%;
    }
    
    .dashboard-welcome {
    top: 145px;
    width: 70%;
    padding: 8px 0px;
        
    }
    
    .dashboard-welcome h1 {
    font-size: 110%;
    }

}

/* Mobile menu */
.mobile-menu-dash {
    position: fixed;
    bottom: 90px;
    right: 20px;
    background: #424242;
    padding: 1px 15px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.5);
    z-index: 100;
}

.mobile-menu-dash ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.mobile-menu-dash ul li {
    margin: 17px 10px;
    font-size: 20px;
    cursor: pointer;
    color: white;
    transition: color 0.3s ease; /* Smooth transition for hover effect */
    
}

.mobile-menu-dash ul li:hover {
    color: #007bff;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX,4CAA4C;AAC5C,gDAAgD;AAChD,4CAA4C;;AAE5C,6DAA6D;AAC7D;IACI,UAAU,EAAE,kCAAkC;AAClD;;AAEA,yCAAyC;AACzC;IACI,6BAA6B;IAC7B,sBAAsB,EAAE,8CAA8C;IACtE,kBAAkB,EAAE,6BAA6B;AACrD;;AAEA,6DAA6D;AAC7D;IACI,sBAAsB,EAAE,2BAA2B;AACvD;;AAEA,oDAAoD;AACpD;IACI,uDAAuD;IACvD,uBAAuB;AAC3B;;AAEA,4EAA4E;AAC5E;IACI,UAAU,EAAE,qCAAqC;AACrD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,2CAA2C;IAC3C,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA,WAAW;AACX;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,eAAe;AACnB;;AAEA,oCAAoC;AACpC;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,eAAe;IACf,UAAU;;IAEV,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;;IAEZ,2BAA2B;IAC3B,gCAAgC;;IAEhC,2BAA2B;IAC3B,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,4BAA4B;IAC5B,cAAc;IACd,4BAA4B;IAC5B,+BAA+B;IAC/B,eAAe;IACf,YAAY;IACZ,4DAA4D;IAC5D,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA,sCAAsC;AACtC;IACI,gBAAgB;IAChB,kBAAkB,EAAE,wDAAwD;IAC5E,eAAe;AACnB;;AAEA,6DAA6D;AAC7D;IACI,oCAAoC;IACpC,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB,EAAE,uBAAuB;IACzC,eAAe;IACf,gBAAgB;;IAEhB,iCAAiC;IACjC,kBAAkB,EAAE,mDAAmD;IACvE,aAAa,EAAE,wCAAwC;IACvD,kBAAkB,EAAE,sBAAsB;;IAE1C,0CAA0C;IAC1C,yBAAyB;IACzB,mBAAmB,EAAE,iCAAiC;IACtD,uDAAuD;AAC3D;;AAEA;IACI,cAAc,EAAE,yBAAyB;IACzC,yBAAyB,EAAE,mCAAmC;AAClE;;AAEA,8CAA8C;AAC9C;IACI,yBAAyB,EAAE,sCAAsC;IACjE,YAAY;IACZ,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;IACI;QACI,cAAc;;IAElB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;QACvB,WAAW;QACX,SAAS;QACT,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;IACA,UAAU;IACV,UAAU;IACV,gBAAgB;;IAEhB;;IAEA;IACA,eAAe;IACf;;AAEJ;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,2BAA2B,EAAE,uCAAuC;;AAExE;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/* Layout */\n\n/* ======================================= */\n/* 🌟 MINIMALIST SCROLLBAR STYLING (WEBKIT) 🌟 */\n/* ======================================= */\n\n/* 1. Target the main scrollbar track (the background area) */\n::-webkit-scrollbar {\n    width: 8px; /* Width of the entire scrollbar */\n}\n\n/* 2. Target the thumb (the moving bar) */\n::-webkit-scrollbar-thumb {\n    /* Base style for the thumb */\n    background-color: #555; /* Dark gray color (visible against #303030) */\n    border-radius: 4px; /* Slightly rounded corners */\n}\n\n/* 3. Hover effect for the thumb (optional, but nice touch) */\n::-webkit-scrollbar-thumb:hover {\n    background-color: #777; /* Lighter color on hover */\n}\n\n/* 4. Target the track (the area behind the thumb) */\n::-webkit-scrollbar-track {\n    /* Make the track transparent or match the background */\n    background: transparent; \n}\n\n/* Optional: To customize scrollbars in specific elements like the sidebar */\n.sidebar::-webkit-scrollbar {\n    width: 6px; /* A little thinner for the sidebar */\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n    background-color: #6a6a6a;\n}\n\n.dashboard {\n    display: grid;\n    grid-template-columns: 0px 1fr;\n    grid-template-rows: 60px 1fr;\n    min-height: 100vh;\n    background: #303030;\n    color: white;\n    transition: grid-template-columns 0.3s ease;\n    padding-top: 84px;\n}\n\n.dashboard.sidebar-open {\n    grid-template-columns: 250px 1fr;\n}\n\n/* Header */\n.dashboard-header {\n    grid-column: 1 / -1;\n    grid-row: 1;\n    display: flex;\n    align-items: center;\n    background: #424242;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    position: fixed;\n    top: 80px;\n    padding: 0px 30px;\n    height: 60px;\n    width: 100%;\n    border-top: 4px solid #303030;\n    z-index: 100;\n}\n\n.dashboard-header h1 {\n    font-family: 'GlitchGoblin', sans-serif;\n    letter-spacing: 3px;\n    font-size: 25px;\n}\n\n/* Hamburger button - desktop only */\n.hamburger_dashboard {\n    cursor: pointer;\n    font-size: 30px;\n    margin-right: 20px;\n    color: white;\n    display: block;\n}\n\n.dashboard-welcome {\n    grid-row: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    position: fixed;\n    top: 144px;\n\n    /* Size based on text content */\n    width: fit-content;\n    padding: 10px 10px;\n    height: 20px;\n\n    /* Rounded bottom corners */\n    border-radius: 0px 0px 20px 20px;\n\n    /* 👇 Center horizontally */\n    left: 50%;\n    transform: translateX(-50%);\n    text-align: center;\n}\n\n\n.dashboard-welcome h1 {\n    font-size: 15px;\n    margin: 0px 5px;\n    font-weight: 300;\n}\n\n/* Sidebar */\n.sidebar {\n    background: #424242;\n    height: calc(100vh - 0%);\n    position: fixed;\n    border-right: 1px solid #555;\n    overflow: auto;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n    margin: 60px 0%;\n    z-index: 100;\n    /* Adjusted width to 250px to provide better padding space */\n    width: 250px; \n}\n\n.sidebar.open {\n    transform: translateX(0);\n}\n\n.sidebar.open h2 {\n    font-size: 20px;\n}\n\n.sidebar h2 {\n    color: white;\n    margin-bottom: 5px;\n}\n\n/* UPDATED: Container for list items */\n.sidebar ul {\n    list-style: none;\n    padding: 10px 10px; /* Added horizontal padding to create \"floating\" space */\n    margin-top: 0px;\n}\n\n/* 🌟 UPDATED: RECTANGULAR MENU ITEM WITH CURVED CORNERS 🌟 */\n.sidebar li {\n    /* Style for the rectangular shape */\n    display: block; \n    color: white;\n    font-size: 15px;\n    list-style: none; /* removes the bullet */\n    cursor: pointer;\n    font-weight: 500;\n    \n    /* 1. Rectangular Shape & Curve */\n    padding: 12px 15px; /* Vertical and horizontal padding inside the box */\n    margin: 8px 0; /* Vertical spacing between menu items */\n    border-radius: 8px; /* ⬅️ CURVED CORNERS */\n    \n    /* Base background color and transitions */\n    background-color: #5a5a5a;\n    border-bottom: none; /* Remove old list item divider */\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.sidebar li:hover {\n    color: #424242; /* Darker text on hover */\n    background-color: #f8f8f8; /* Highlight the rectangular item */\n}\n\n/* Style for the actively selected menu item */\n.sidebar li.active {\n    background-color: #007bff; /* Primary color for the active item */\n    color: white; \n    font-weight: 700;\n    box-shadow: 0 1px 3px rgba(0, 123, 255, 0.4);\n}\n\n.menu-section {\n    padding: 5px 15px;\n}\n\n/* Main Content */\n.main-content {\n    grid-column: 2;\n    grid-row: 2;\n    padding: 30px 10px;\n    background: #303030;\n    overflow-y: auto;\n}\n\n.main-content h1 {\n    color: white;\n    font-size: 25px;\n    font-weight: 400;\n    text-align: center;\n}\n\n.username {\n    font-size: 15px;\n    font-weight: 600;\n    list-style: none;\n    color: #007bff;\n    padding-right: 2px;\n}\n\n/* FAB button for mobile */\n.fab {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 60px;\n    height: 60px;\n    font-size: 30px;\n    cursor: pointer;\n    display: none;\n    z-index: 100;\n}\n\n/* Show FAB only on mobile */\n@media (max-width: 770px) {\n    .fab {\n        display: block;\n        \n    }\n    \n    .hamburger_dashboard {\n        display: none;\n    }\n    \n    .dashboard {\n        padding-top: 70px;\n    }\n    \n    .dashboard-header {\n        justify-content: center;\n        padding: 0%;\n        top: 82px;\n        border-top: 4px solid #303030;\n    }\n    \n    .dashboard-header h1 {\n        font-size: 18px;\n    }\n    \n    .main-content h1 {\n        font-size: 18px;\n        margin: 1% 0%;\n    }\n    \n    .main-content {\n        padding: 70px 15px;\n    }\n    \n    .username {\n        font-size: 110%;\n    }\n    \n    .dashboard-welcome {\n    top: 145px;\n    width: 70%;\n    padding: 8px 0px;\n        \n    }\n    \n    .dashboard-welcome h1 {\n    font-size: 110%;\n    }\n\n}\n\n/* Mobile menu */\n.mobile-menu-dash {\n    position: fixed;\n    bottom: 90px;\n    right: 20px;\n    background: #424242;\n    padding: 1px 15px;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0,0,0,0.5);\n    z-index: 100;\n}\n\n.mobile-menu-dash ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.mobile-menu-dash ul li {\n    margin: 17px 10px;\n    font-size: 20px;\n    cursor: pointer;\n    color: white;\n    transition: color 0.3s ease; /* Smooth transition for hover effect */\n    \n}\n\n.mobile-menu-dash ul li:hover {\n    color: #007bff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
